import React, { useState } from "react";
import axios from "axios";
import ImageUpload from "../../../../../../components/elements/ImageUpload";
import { ADMIN_API_BASE } from "../../../../../../utils/apiConfig";
import { resolveCourseImageUrl } from "../../../../../../utils/mediaResolver";

export default function ImageBlockEditor({ block, onChange, courseId }) {
    const [isUploading, setIsUploading] = useState(false);

    const getCsrfToken = async () => {
        const response = await fetch(`${ADMIN_API_BASE}/csrf-token`, {
            method: "GET",
            credentials: "include", // critical to send the session cookie
        });

        const data = await response.json();
        return data.csrfToken;
    };

    const handleFileChange = async (file) => {
        if (!file) {
            onChange({ config: { ...block.config, src: "" } });
            return;
        }

        const localPreview = URL.createObjectURL(file);
        onChange({ config: { ...block.config, src: localPreview } });

        setIsUploading(true);

        const formData = new FormData();
        formData.append("image", file);
        formData.append("folder", "content");
        formData.append("slug", `${courseId}`); // ارسال slug اختیاری به بک‌اند

        try {
            const token = await getCsrfToken();
            const res = await axios.post(
                `${ADMIN_API_BASE}/course/${courseId}/upload-image`,
                formData,
                {
                    headers: {
                        'csrf-token': token,
                    },
                    withCredentials: true
                }
            );

            if (!res.data?.success) throw new Error("Upload failed");

            // دریافت کلید فایل آپلود شده
            const key = res.data.key || res.data.url;

            if (!key) throw new Error("No key returned from server");

            // ۴. ذخیره موفقیت‌آمیز کلید CDN به جای blob موقت
            onChange({
                config: {
                    ...block.config,
                    src: key
                }
            });
        } catch (err) {
            console.error(err);
            alert("خطا در آپلود تصویر");
            onChange({ config: { ...block.config, src: "" } });
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <div className="space-y-3">
            {/* کامپوننت آپلود تصویر تعاملی */}
            <ImageUpload
                name="Image"
                existingImage={resolveCourseImageUrl(block.config?.src, { isPrivate: true }) || ""}
                isPrivate={true}
                onFileChange={handleFileChange}
            />

            {/* نمایش وضعیت آپلود */}
            {isUploading ? (
                <p className="text-xs text-blue-500 animate-pulse font-medium">
                    در حال آپلود و بهینه‌سازی در CDN...
                </p>
            ) : block.config?.src ? (
                <div className="flex flex-col gap-2">
                    {/* آدرس کلید فایل در بک‌اند */}
                    <p className="text-[10px] text-gray-400 truncate dir-ltr text-left">
                        {block.config.src}
                    </p>

                    {/* ورودی متن جایگزین تصویر */}
                    <input
                        className="w-full p-2 text-sm border rounded-xl bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                        placeholder="متن جایگزین (Alt Text)"
                        value={block.config.alt || ""}
                        onChange={(e) =>
                            onChange({
                                config: {
                                    ...block.config,
                                    alt: e.target.value
                                }
                            })
                        }
                    />
                </div>
            ) : null}
        </div>
    );
}
